import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';
import { Index } from '@client/style/Variables';

const BurgerContainer = styled.button<{ $color?: string }>`
	position: fixed;
	z-index: ${Index.mainMenuButton};
	color: ${props => props.$color};
	top: 15px;
	right: 10px;
	appearance: none;
	background: transparent;
	padding: 18px;
`;

const StyledIconWrapper = styled.div`
	width: 28px;
	height: 16px;
	position: relative;
`;

const StyledBurgerBar = styled.div`
	width: 100%;
	height: 4px;
	background: currentColor;
	position: absolute;
	left: 0;
	&:nth-child(1) {
		top: 0;
	}
	&:nth-child(2) {
		bottom: 0;
	}
`;

export const MenuBurger = (props: { open: boolean; color?: string; toggleOpen: () => void }) => {
	const bar1Tween = useRef<gsap.core.Tween>(undefined);
	const bar2Tween = useRef<gsap.core.Tween>(undefined);
	const bar1Ref = useRef<HTMLDivElement>(null);
	const bar2Ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		bar1Tween.current = gsap.to(bar1Ref.current, {
			rotate: props.open ? -45 : 0,
			duration: 0.85,
			y: props.open ? '150%' : '0%',
			delay: -0.2,
			ease: 'elastic.inOut(1.75, 0.5)',
		});

		bar2Tween.current = gsap.to(bar2Ref.current, {
			rotate: props.open ? 45 : 0,
			y: props.open ? '-150%' : '0%',
			duration: 1,
			delay: -0.2,
			ease: 'elastic.inOut(1.75, 0.5)',
		});

		return () => {
			bar1Tween.current?.kill();
			bar2Tween.current?.kill();
		};
	}, [props.open]);

	return (
		<BurgerContainer onClick={props.toggleOpen} $color={props.color}>
			<StyledIconWrapper>
				<StyledBurgerBar ref={bar1Ref} />
				<StyledBurgerBar ref={bar2Ref} />
			</StyledIconWrapper>
		</BurgerContainer>
	);
};
